import { AUTH_CHECK, AUTH_ERROR, AUTH_GET_PERMISSIONS, AUTH_LOGIN, AUTH_LOGOUT } from 'react-admin'
import { ROLE_ORGA_USER } from './pages/configuration/actions'
import {
    getUserRole,
    getValidAccessToken,
    isAuthTransientError,
    performLogout,
} from './auth/tokenStore';
import { ensureUserOrganization } from './helper/resourceHelper';

// Outcome of getValidAccessToken() → decision:
//   token     → authenticated
//   null      → no session: reject, react-admin calls logout
//   transient → offline / auth service error: NOT a sign-out condition. Keep
//               the session; the request that needed the token surfaces its
//               own error and the next call retries.
const checkSession = async (opts) => {
    try {
        const token = await getValidAccessToken(opts);
        // Reject with a real Error: react-admin runs this inside a react-query
        // query, whose logger prints the rejected value on the console.
        return token ? Promise.resolve() : Promise.reject(new Error('Not authenticated'));
    } catch (error) {
        if (isAuthTransientError(error)) return Promise.resolve();
        throw error;
    }
};

const authProvider = async (type, params) => {

    if (type === AUTH_LOGIN) {
        return Promise.resolve()
    }

    if (type === AUTH_LOGOUT) {
        await performLogout();
        // The store issues its own top-level navigation (Cognito /logout, or
        // /init-login when there is no session left). `false` tells
        // react-admin not to navigate to /login itself, which would race that
        // navigation and could re-trigger a sign-in.
        return false;
    }

    if (type === AUTH_ERROR) {
        const { status } = params;
        if (status === 401) {
            // forceRefresh: Amplify would otherwise return the same cached token
            return checkSession({ forceRefresh: true });
        }
        return Promise.resolve()
    }

    if (type === AUTH_CHECK) {
        return checkSession();
    }

    if (type === AUTH_GET_PERMISSIONS) {
        // Resolve the user's organization from the server once per login
        // (organization id + root-organization membership for isROAdmin)
        // before permissions are handed out.
        await ensureUserOrganization();
        const role = getUserRole();
        return role ? Promise.resolve(role) : ROLE_ORGA_USER
    }

    return Promise.reject('Unknown method')
}

export default authProvider;
